import React, { Fragment } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import ReactResizeDetector from 'react-resize-detector';
import { getUserInfo } from "./constants/apiCalls";
import Storage from "./services/Storage";
import { handleErrorMessage } from "./utils/utils";
import ModalService from "./services/ModalService";
import { getPermissionUser, getUserInfoDetail } from "./reducers/UserGetReducer";
import MainRoutes from "./Routes/MainRoutes";

//services

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // closedSmallerSidebar: false,
      isDisconnected: false,
      noNetworkImage: "images/no-network.svg",
      // permissionsState: Storage.getUserPermissionDetail()
      permissionsState: props.arrPermissionState,
      userState : props.userInfoDetailState,
    };
    let token = Storage.getTokenDetail();
    if (token.accessToken) {
      this.getUserDetails();
    }
  }


  getUserDetails() {
    getUserInfo((res) => {
      const { data, success, error } = res;
      if (success === true) {
        this.props.getPermissionUser(data.permissions);
        this.setState({ permissionsState: this.props.arrPermissionState })

        this.props.getUserInfoDetail(data);
        this.setState({ userState: this.props.userInfoDetailState })
        
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
      }
    });
  }

  render() {
    let {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      enablePageTabsAlt,

      // arrPermissionState,
      // getPermissionUser
    } = this.props;

    return (
      <ReactResizeDetector
        handleWidth
        render={({ width }) => (
          <Fragment>
            <div
              className={cx(
                "app-container app-theme-" + colorScheme,
                { "fixed-header": enableFixedHeader },
                { "fixed-sidebar": enableFixedSidebar || width < 1440 },
                { "fixed-footer": enableFixedFooter },
                // { "closed-sidebar": enableClosedSidebar || width < 1440 },
                { "closed-sidebar": true },
                {
                  "closed-sidebar-mobile": closedSmallerSidebar || width < 1440,
                },
                { "sidebar-mobile-open": enableMobileMenu },
                { "body-tabs-shadow-btn": enablePageTabsAlt }
              )}
            >
              <MainRoutes />
            </div>
          </Fragment>
        )}
      />
    );
  }
}

const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
  arrPermissionState: state.UserGetReducer.permissionArr,
  userInfoDetailState: state.UserGetReducer.userInfoDetail,
});

// export default withRouter(connect(mapStateToProp, {getPermissionUser, getUserInfoDetail})(App));
export default connect(mapStateToProp, {getPermissionUser, getUserInfoDetail})(App);
